export default {"src":"/_next/static/media/car_listed.b5a68ad3.svg","height":63,"width":86};